import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faTimesCircle
} from "@fortawesome/free-solid-svg-icons";
function SearchData(props) {

    const [filterData, setFilterData] = useState()
    const [selectedCountry, setSelectedCountry] = useState("")
    const [selectedCountryShow, setselectedCountryShow] = useState(false)

    const search = (text) => {
        let data = props.alldata.filter((item) => {
            const regex = new RegExp(`${text.trim()}`, "gi");
            if (regex == "/(?:)/gi") {
                return props.alldata;
            } else {
                return (
                    item.country_name.match(regex)
                );
            }
        });
        setFilterData(data);
        console.log('data', data);
    };


    return (

        <div className={`${props.width ? props.width : 'col-md-4'} col-6`}>
            <label>{props.lable}</label>
            <div className="input-group">
                {selectedCountryShow ?
                    <>
                        <input
                            type="text"
                            id="countrycode"
                            className="form-control"
                            value={selectedCountry}
                            disabled

                        />
                        <span class="input-group-text" id="basic-addon2"><FontAwesomeIcon role="button" onClick={() => {
                            setFilterData(null)
                            setselectedCountryShow(false)

                        }} icon={faTimesCircle} color="red" /></span></>
                    :
                    <input
                        type="text"
                        id="countrycode"
                        onChange={(e) => search(e.target.value)}
                        placeholder={`${props.placeholder}`}
                        className="form-control"


                    />
                }
            </div>
            {filterData &&
                <ul className="fiter-options">
                    {
                        filterData.map((item, index) =>
                            <li onClick={() => {
                                setSelectedCountry(item.country_code)
                                setFilterData(null)
                                props.setData(item.country_code);
                                setselectedCountryShow(true)

                            }} value={item.country_code} key={index}>{item.country_name}</li>
                        )
                    }
                </ul>
            }
        </div>
    );
}

export default SearchData;
